import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { getBackupFile } from '../utils/getBackupFile'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useDownloadBackupMutation = () => {
  return useMutation({
    mutationFn: getBackupFile,
    onSuccess: () => {
      toast.success('Backup file downloaded successfully.')
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while downloading the backup file.',
      )
    },
  })
}
